"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderViewCommand = void 0;
class RenderViewCommand extends CustomEvent {
    constructor(identifier, viewType, placeholderElement) {
        const detail = {
            identifier,
            viewType,
            placeholderElement
        };
        super('', { detail });
    }
}
exports.RenderViewCommand = RenderViewCommand;
